<template>
  <div>
    <custom-callout
      border-color="orange"
      class="mb-4 custom-callout-invoice shadow"
      :has-toggle="false"
    >
      <div class="row">
        <div class="col-md-12">
          <icon-view
            icon="fa fa-exchange-alt mb-1 mt-1"
            icon-background="#FF7058"
            icon-color="#fff"
            title="Cambiar estatus de la factura"
          />
        </div>
      </div>
      <validation-observer
        ref="submitUpdateBillingStatusRef"
        novalidate
        tag="form"
      >
        <div class="row my-4">
          <div class="col-md-3 col-12">
            <div class="gray-6 font-14 mb-2">
              Estatus:
            </div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="bill-change-status-dropdown-status"
                v-model="billingStatusModel.billStatus"
                :clearable="false"
                custom-error-msg="El estatus es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="billingStatusListAvailable"
                placeholder="Seleccione"
                @input="onChangeStatus"
              />
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <div class="gray-6 font-14 mb-2">
              Comentario:
            </div>
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-input
                id="bill-change-status-input-comment"
                v-model="billingStatusModel.comment"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                maxlength="500"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-12 text-right mt-4">
            <action-button
              id="bill-change-status-button-cancel"
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
              @click="$emit('on-cancel-change-billing-status')"
            >
              Cancelar
            </action-button>
            <action-button
              id="bill-change-status-button-continue"
              i="fas fa-arrow-circle-right"
              variant="success pl-4 pr-4"
              @click="onSubmitBillingStatusHandler"
            >
              Continuar
            </action-button>
          </div>
        </div>
      </validation-observer>
    </custom-callout>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'BillChangeStatus',
  components: {
    CustomCallout,
    CustomDropDown,
    IconView,
    ActionButton,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  props: {
    billingStatusListAvailable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      billingStatusModel: {
        billStatus: null,
        comment: '',
      },
    };
  },
  methods: {
    async onSubmitBillingStatusHandler() {
      const isValid = await this.$refs.submitUpdateBillingStatusRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      this.$emit('on-submit-change-billing-status', this.billingStatusModel);
    },
    onChangeStatus() {
      this.billingStatusModel.comment = '';
      if (this.billingStatusModel.billStatus) {
        this.billingStatusModel.comment = `Factura cambiada a ${this.billingStatusModel.billStatus.name} por ${this.userRole}.`;
      }
    },
  },
};
</script>
